import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "../style";
import { baseColors } from "theme";

interface Props extends WithStyles<typeof styles> {
	color?: string;
	value: number;
	text: string;
}

const Component = (props: Props) => {
	const { color = baseColors.gray100, value, text, classes = {} } = props;
	return (
		<Mui.Grid item className={classes.row}>
			<Mui.Avatar className={classes.avatar} style={{ backgroundColor: baseColors.gray100, color: baseColors.black, fontSize: 16 }}>
				{value}
			</Mui.Avatar>
			<Mui.Typography variant="h4" {...{ style: { textTransform: "capitalize", fontSize: 16 } }}>{text}</Mui.Typography>
		</Mui.Grid>
	);
}

export const Left = withStyles(Component, styles);